<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
            <h3>Conexión con dispositivo</h3>
        </v-flex>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field
                flat
                slot
                prepend-icon="search"
                placeholder="Buscar"
                v-model="search"
                hide-details
                class="hidden-sm-and-down"
              >
              </v-text-field>
                <v-btn icon></v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :search="search"
                :items="complex.items"
                :loading="loading"
                :rows-per-page-items="[10,25,50,{text:'All','value':-1}]"
                class="elevation-1"
                item-key="name"
                v-model="complex.selected"
              >
              <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
              <template slot="items" slot-scope="props">
                <td>{{props.item.nombre}}</td>
                <td>{{props.item.serial}}</td>
                <td>{{props.item.ip}}</td>
                <td>{{props.item.puerto}}</td>
                <td>{{props.item.comm_key}}</td>
                <td>
                  <v-btn icon fab dark @click="conexion()" color="indigo" small>
                    <v-icon>compare_arrows</v-icon>
                  </v-btn>
                  <v-btn icon fab dark @click="abrirModal('update',props.item)" color="blue-grey" small>
                    <v-icon>edit</v-icon>
                  </v-btn>
                  <v-btn icon fab dark color="red" small @click="eliminar(props.item.id, props.item.serial)">
                    <v-icon>delete</v-icon>
                  </v-btn>
                </td>
              </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-tooltip top>        
        <v-btn dark color="info" slot="activator"  class="v-btn v-btn--bottom v-btn--floating v-btn--fixed v-btn--right theme--dark blue"
          @click="abrirModal('add')" style="transform-origin: center center 0px;">
          <v-icon dark>fingerprint</v-icon>
        </v-btn>
        <span>Agregar</span>
      </v-tooltip>
    </v-container>   
  </div>
</template>

<script>
export default {
  data(){
    return{
      loading:false,
      dialog:true,
      search:"",
      complex:{
        selected:[],
        headers:[
          {
            text:"Nombre del dispositivo",
            value:"nombre"
          },
          {
            text:"Número de serie",
            value:"serial"
          },
          {
            text:"Dirección IP",
            value:"ip"
          },
          {
            text:"Puerto",
            value:"puerto"
          },
          {
            text:"CommKey",
            value:"comm_key"
          },
          {
            text: "Opciones",
            value: ""
          }
        ],
        items:[
          {
            nombre:"Reloj México",
            serial:"A8ME182460325",
            ip:"192.168.212.15",
            puerto:"4370",
            comm_key:"0"
          },
          
        ]
      }
    }
  }
}
</script>


<style scoped>

</style>

